import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.clearBlue,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.darkNight,
  textColorLight: colors.white
};
export default accordion;